import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseCategoriesAccountingRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoriesAccountingAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategories,
  routeProps: expenseCategoriesAccountingRouteProps,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoriesAccountingAppRoute
